import { Link } from 'react-router-dom';
import Reveal from '@/components/base/Reveal';
import { aboutValues } from '@/mocks/community';

export default function HomeBrand() {
  return (
    <section className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-[1fr_1.15fr] lg:gap-12">
          <Reveal>
            <div className="relative h-[300px] w-full overflow-hidden rounded-lg md:h-[440px]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cream%20paper%20texture%20with%20layered%20stacked%20index%20cards%20and%20a%20magnifying%20glass%2C%20soft%20natural%20window%20light%20casting%20gentle%20diagonal%20shadows%2C%20muted%20terracotta%20and%20oat%20tones%2C%20editorial%20still%20life%20photography%2C%20calm%20minimal%20composition%2C%20no%20readable%20text%2C%20no%20people&width=1000&height=1100&seq=brand-paper-texture-01&orientation=portrait"
                alt="奶油色纸张与卡片堆叠的静物，象征线索整理"
                title="爆料吃瓜 · 把线索整理成看得懂的时间线"
                className="h-full w-full object-cover"
              />
              <div className="absolute bottom-4 left-4 right-4 rounded-lg bg-background-50/95 p-4 backdrop-blur">
                <p className="font-heading text-sm font-bold text-foreground-950">线索整理，而不是结论输出</p>
                <p className="mt-1 text-xs leading-relaxed text-foreground-600">
                  每一条记录都保留来源、时间与证据强度，方便你自己判断。
                </p>
              </div>
            </div>
          </Reveal>

          <div>
            <Reveal delay={60}>
              <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.28em] text-primary-600">
                <span className="h-px w-6 bg-primary-500" />
                About Us
              </span>
              <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-[32px]">
                我们只做三件事：整理、标注、留给别人讨论
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
                娱乐爆料最有意思的地方从来不是结论，而是推理过程。所以我们把公开信息和网友投稿放到同一张时间线上，
                标清哪些是视频、哪些只是截图、哪些完全没法验证——剩下的事，交给评论区。
              </p>
            </Reveal>

            <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {aboutValues.map((value, index) => (
                <Reveal key={value.id} delay={index * 70}>
                  <div className="h-full rounded-lg border border-background-200 bg-background-50 p-4">
                    <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                      <i className={`${value.icon} text-lg`} aria-hidden="true" />
                    </span>
                    <h3 className="mt-3 font-heading text-sm font-bold text-foreground-950">{value.title}</h3>
                    <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{value.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>

            <Reveal delay={120}>
              <Link
                to="/about"
                className="mt-7 inline-flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
              >
                了解更多关于我们的故事
                <i className="ri-arrow-right-line" aria-hidden="true" />
              </Link>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}